(function () {
    'use strict';

    var module = angular.module('uwAgenda.settings.grouppractice');
    module.controller('GroupPracticeOverviewController', [GroupPracticeOverviewControllerFn]);

    /* controlle for email-overview */
    function GroupPracticeOverviewControllerFn(
) {
            
    }
})();
